<nz-drawer
    [nzClosable]="true"
    [nzVisible]="open"
    nzPlacement="right"
    [nzWidth]="_mobile() ? '100%' : '750px'"
    [nzBodyStyle]="{ position: 'relative' }"
    [nzTitle]="titleTpl"
    (nzOnClose)="close()">
    <ng-container *nzDrawerContent>
        <div class="layout fit vertical p1 gv05 flines scroll-y" [class.mobile]="_mobile()">
            @if (_error()) {
                <div class="layout flex center-center">
                    <vz-error-panel [error]="_error()" />
                </div>
            }
            @else {
                @if (canChangeType() && !tagId()) {
                    <nz-segmented class="mb05 ant-segmented-border"
                        nzBlock
                        [(ngModel)]="tagType"
                        (ngModelChange)="changed.set(true)">
                        <label nz-segmented-item nzValue="org">
                            <div>Тег доступен всем в организации</div>
                            <vz-avatar class="d-ib" type="org" withName="true" [uid]="activeOrgId" />
                        </label>
                        <label nz-segmented-item nzValue="proj">
                            <div>Тег доступен только команде проекта</div>
                            <vz-avatar class="d-ib" type="project" withName="true" [uid]="projectId()" />
                        </label>
                    </nz-segmented>
                }
                @else if (projectId()) {
                    <span class="b1s bc-warn bg-t-warn br8 center layout mb05 pv05 vertical">
                        <div class="fw-b">Тег доступен только команде проекта</div>
                        <div class="layout center gap025">
                            <vz-project-badge [guid]="projectId()" size="14" />
                            <vz-avatar type="project" withName="true" noImg="true" [uid]="projectId()" size="24" />
                        </div>
                    </span>
                }
                @else {
                    <div class="b1s bc-warn bg-t-warn br8 mb05 pv05 tac fw-b">Тег доступен всем в организации</div>
                }

                @if (parentId()) {
                    <div class="layout">
                        <div class="mr05 flex-2 tar txt-l">Родительский тег:</div>
                        <div class="layout flex-10 gap05">
                            <vz-tag [tagId]="parentId()" />
                        </div>
                    </div>
                }

                <div class="layout center">
                    <div class="mr05 flex-2 tar txt-l">Название:</div>
                    <input
                        class="flex-10"
                        type="text"
                        nz-input
                        placeholder="Название"
                        [nzStatus]="changed() && !text() ? 'error' : ''"
                        [aFocus]="!tagId() ? 800 : -1"
                        [(ngModel)]="text"
                        (ngModelChange)="changed.set(true)" />
                </div>
                <div class="layout">
                    <div class="mr05 flex-2 tar txt-l">Описание:</div>
                    <textarea class="flex-10" type="text" nz-input placeholder="Описание" [nzAutosize]="{ minRows: 3, maxRows: 10 }" [(ngModel)]="description" (ngModelChange)="changed.set(true)"></textarea>
                </div>
                <div class="layout">
                    <div class="mr05 flex-2 tar txt-l">Уникальность:</div>
                    <label class="flex-10" nz-checkbox [(ngModel)]="uniqueGroup" (ngModelChange)="changed.set(true)">Одновременно можно назначить только один тег из этой группы</label>
                </div>
                <span class="layout center">
                    <div class="mr05 tar txt-l" [class.flex-2]="!_mobile()">Цвет фона:</div>
                    <div class="flex-10">
                        <span class="ced-color layout op08"
                            [style.background-color]="color()"
                            [style.border-color]="color()"
                            (click)="showSelectColor.set(true)">
                            <span>&nbsp;&nbsp;</span>
                        </span>
                    </div>
                </span>
                @if (showIcon()) {
                    <span class="layout center">
                        <div class="mr05 flex-2 tar txt-l">Значок:</div>
                        <div class="flex-10">
                            <div class="layout center-center ced-icon" [style.background-color]="color()">
                                <i [ngClass]="icon()" (click)="showSelectIcon.set(true)"></i>
                            </div>
                        </div>
                    </span>
                }
                <div class="vz-panel vz-panel-m layout vertical gap05 mt1">
                    <div class="vz-panel-title">Параметры отображения:</div>
                    <label nz-checkbox [(ngModel)]="showIcon" (ngModelChange)="changed.set(true)">Отображать значок</label>
                    <label nz-checkbox [(ngModel)]="showText" (ngModelChange)="changed.set(true)">Отображать текст</label>
                    <label nz-checkbox [(ngModel)]="showTagParent" (ngModelChange)="changed.set(true)">Отображать данный тег для вложенных тегов</label>
                    @if (showTagParent()) {
                        @if (showIcon()) {
                            <label class="ml1" nz-checkbox [(ngModel)]="showIconParent" (ngModelChange)="changed.set(true)" animate.enter="vza-show-h" animate.leave="vza-hide-h">Отображать значок для вложенных тегов</label>
                        }
                        @if (showText()) {
                            <label class="ml1" nz-checkbox [(ngModel)]="showTextParent" (ngModelChange)="changed.set(true)" animate.enter="vza-show-h" animate.leave="vza-hide-h">Отображать текст для вложенных тегов</label>
                        }
                    }
                </div>
                <span class="vz-panel vz-panel-m layout vertical gap05 mt1 pb1">
                    <div class="vz-panel-title">Предпросмотр:</div>
                    <div class="layout vertical start gap025 scroll-x">
                        @let ptags = previewTags();
                        @if (ptags) {
                            <b>Тег:</b>
                            @if (ptags[0]; as mt) {
                                <vz-tag [tag]="mt" />
                            }
                            <b class="mt1">Примеры вложенных тегов:</b>
                            @if (ptags.length > 1) {
                                @for (pt of ptags; track pt) {
                                    @if (!$first) {
                                        <vz-tag [tag]="pt" />
                                    }
                                }
                            }
                        }
                    </div>
                </span>
            }
        </div>
    </ng-container>
</nz-drawer>

@if (error) {
    <vz-error-message [error]="error" (dismiss)="error = undefined" />
}

<ng-template #titleTpl>
    <div class="layout center">
        <span class="flex">{{ tagId() ? 'Редактировать тег' : 'Создать новый тег'}}{{ projectId() && (!canChangeType() || tagType() == 'proj') ? ' в проекте' : '' }}</span>
        @if (tagId()) {
            <button class="layout mr05 ant-btn-icon-only"
                title="Удалить этот тег"
                nz-button nzType="dashed" nzGhost nzDanger
                nz-popconfirm
                nzPopconfirmTitle="Уверены? Будут также удалены все вложенные теги если они есть."
                nzPopconfirmPlacement="topRight"
                (nzOnConfirm)="delete()">
                <i class="vzi-trash-o"></i>
            </button>
        }
        <button nz-button nzType="primary" [disabled]="!changed() || !text()" (click)="submit()">{{ tagId() ? 'Сохранить' : 'Создать' }}</button>
    </div>
</ng-template>

@if (showSelectIcon()) {
    <vz-select-icon [color]="color()" (closePanel)="setIcon($event)" />
}
@if (showSelectColor()) {
    <vz-select-color [op]="0.8" (closePanel)="setColor($event)" />
}

<ng-template #tplSelectTag let-item>
    <div class="layout center" style="height: 100%">
        <vz-tag [tagId]="item.nzValue.id" class="mr025"></vz-tag>
    </div>
</ng-template>
